import ContentPopup from './ContentPopup';

export default ContentPopup;
